import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

// import Footer from '../components/Footer';

const AppLayout = ({ children, onAddTechnician }) => {
  const location = useLocation();
  const [isHamburger, setHamburger] = useState(false);
  const deviceName = useSelector((state) => state.auth.deviceName);
  let title = '';
  if (location.pathname.startsWith('/dashboard')) {
    title = 'Dashboard';
  } else if (location.pathname.startsWith('/device/')) {
    // const deviceName = window.DEVICE_NAME;
    title = deviceName ? `Device Statistics - ${deviceName}` : 'Device Statistics';
  } else if (location.pathname.startsWith('/technicians')) {
    title = 'Technicians';
  } else if (location.pathname.startsWith('/alert')) {
    title = 'Alerts';
  } else if (location.pathname.startsWith('/report')) {
    title = 'Reports';
  }
  return (
    <div className="wrapper">
      <aside className={`sidebar-section ${isHamburger ? 'collapsed' : ''}`}>
        <Sidebar
          isHamburger={isHamburger}
          onHamburger={() => setHamburger(!isHamburger)}
        />
      </aside>
      <main className={`main-content ${isHamburger ? 'collapsed' : ''}`}>
        <Header
          title={title}
          onAddTechnician={onAddTechnician}
          onHamburger={() => setHamburger(!isHamburger)}
        />
        <div className="container-wrapper">{children}</div>
        {/* <section
          className="app-content container-fluid p-0"
          style={
            title !== 'Dashboard' ? { borderTop: '1px solid #B2BCCB' } : {}
          }
        >
          {children}
        </section> */}
        {/* <footer className="app-footer">
          <Footer />
        </footer> */}
      </main>
    </div>
  );
};

export default AppLayout;
